import {
  Box,
  Button,
  Card,
  Checkbox,
  CrudMode,
  DataArray,
  DataDisplay,
  formatBoolean,
  Grid,
  GridBreak,
  pn,
  Stack,
  Typography,
  useElementBreakpoints,
  ValidationErrors,
} from "@compass/core";
import { Input, Select } from "components";
import {
  School,
  StaffServiceType,
  StaffServiceTypeEditResource,
  StaffServiceTypeViewResource,
} from "generated/openApi";
import produce from "immer";
import "moment-timezone";

export const BasicInfo = (props: {
  crudMode: CrudMode;
  serviceType: StaffServiceType;
  setServiceType: (value: StaffServiceType) => void;
  viewResource: StaffServiceTypeViewResource;
  editResource: StaffServiceTypeEditResource;
  validationErrors: ValidationErrors;
}) => {
  const { breakpointsRef, smallFieldBreakpoints, largeFieldBreakpoints, fullFieldBreakpoints } =
    useElementBreakpoints();
  const properties = props.viewResource.properties || [];

  const nameField = () => {
    const propertyName = pn<StaffServiceType>("name");
    const property = properties.find((x) => x.propertyName === propertyName);

    return props.crudMode === "view" ? (
      <DataDisplay label={property?.displayName}>{props.serviceType.name}</DataDisplay>
    ) : (
      <Input
        modelProperty={property}
        errors={props.validationErrors[propertyName]}
        value={props.serviceType.name}
        onChange={(e) =>
          props.setServiceType(
            produce(props.serviceType, (draft) => {
              draft.name = e.target.value;
            })
          )
        }
      />
    );
  };

  const schoolField = () => {
    const propertyName = pn<StaffServiceType>("schoolId");
    const property = properties.find((x) => x.propertyName === propertyName);

    return props.crudMode === "view" ? (
      <DataDisplay label={property?.displayName}>{props.serviceType.school?.name}</DataDisplay>
    ) : (
      <Select
        modelProperty={property}
        errors={props.validationErrors[propertyName]}
        value={props.editResource.schools?.find((x) => x.id === props.serviceType.schoolId)}
        options={props.editResource.schools}
        getOptionLabel={(option) => option.name}
        onChange={(e, value) =>
          props.setServiceType(
            produce(props.serviceType, (draft) => {
              draft.schoolId = value?.id;
            })
          )
        }
      />
    );
  };

  const inactiveField = () => {
    const propertyName = pn<StaffServiceType>("inactive");
    const property = properties.find((x) => x.propertyName === propertyName);

    return props.crudMode === "view" ? (
      <DataDisplay label={property?.displayName}>{formatBoolean(props.serviceType.inactive)}</DataDisplay>
    ) : (
      <Stack height="100%" justifyContent={"center"}>
        <Checkbox
          label={property?.displayName}
          checked={props.serviceType.inactive}
          onChange={(e) =>
            props.setServiceType(
              produce(props.serviceType, (draft) => {
                draft.inactive = e.target.checked;
              })
            )
          }
        />
      </Stack>
    );
  };

  return (
    <Card>
      <Grid ref={breakpointsRef} container spacing="sm">
        <Grid item xs={largeFieldBreakpoints}>
          {nameField()}
        </Grid>

        <Grid item xs={fullFieldBreakpoints}>
          {schoolField()}
        </Grid>

        <Grid item xs={smallFieldBreakpoints}>
          {inactiveField()}
        </Grid>
      </Grid>
    </Card>
  );
};
